<!-- ! IMPORTANT RENAME CLASSES AND REMOVE EVENT-FORM WHEN GONNA REUSE THIS -->

<div class="event-form-deep" *ngIf="reservation">
    <div class="dialog-content-wrapper container-event-form">
        <!-- Header -->
        <mat-toolbar class="mat-accent m-0">
            <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
                <span class="title dialog-title">{{ 'reservationDialog.reservation_test' | transloco }}</span>
                <button mat-icon-button (click)="closeThis()" [attr.aria-label]="'reservationDialog.close' | transloco">
                    <mat-icon class="fail" style="background: inherit !important">close</mat-icon>
                </button>
            </mat-toolbar-row>
        </mat-toolbar>


        <!-- Form Container -->
        <div class="p-24 m-0" style="overflow-y: auto; overflow-x: visible" fusePerfectScrollbar>
            <form name="eventForm" autocomplete="off" [formGroup]="reservationForm" class="event-form w-100-p"
                fxLayout="column">

                <!-- First Row -->
                <div fxLayout="row" fxLayout.xs="column" class="mb-12 reservation-form-row">
                    <div class="div-large w-100-p field-stack" fxLayout="column" fxLayoutAlign="start start">
                        <label fxHide.xs class="input-label ">{{ 'reservationDialog.full_name' | transloco }}</label>

                        <mat-label fxHide.gt-xs>{{ 'reservationDialog.full_name' | transloco }}</mat-label>
                        <label matInput mat-maxlength="250" max-rows="4" class="mb-12"> {{reservation.fullname}}
                        </label>
                    </div>
                    <div class="div-large w-100-p field-stack" fxLayout="column" fxLayoutAlign="start start">
                        <label fxHide.xs class="input-label ">{{ 'reservationDialog.phone' | transloco }}</label>

                        <mat-label fxHide.gt-xs>{{ 'reservationDialog.phone' | transloco }}</mat-label>
                        <label class="mb-12" matInput mat-maxlength="250" max-rows="4">
                            {{reservation.phone}}

                        </label>

                    </div>

                </div>

                <!-- Second Row -->
                <div fxLayout="row" fxLayout.xs="column" class="mb-12 reservation-form-row">
                    <div class="div-large w-100-p field-stack" fxLayout="column" fxLayoutAlign="start start">
                        <label fxHide.xs class="input-label ">{{ 'reservationDialog.category' | transloco }}</label>

                        <mat-label fxHide.gt-xs>{{ 'reservationDialog.category' | transloco }}</mat-label>
                        <label class="mb-12" matInput mat-maxlength="250" max-rows="4">
                            {{ getCategoryName(reservation.categorie) }}

                        </label>
                    </div>

                    <!-- <div fxLayout="column" class="div-large w-100-p  paddingL paddingR" fxHide.xs>
                        <label class="input-label ">Dureé(Hr) (الوقت) </label>




                        <label class="mb-12"> 1 heure</label>
                    </div>
                    <div class="pl-20" fxLayout="column" floatLabel="always" fxHide.gt-xs>



                        <label>Dureé(Hr) (الوقت)</label>

                        <label class="mb-12"> 1 heure</label>


                    </div> -->



                </div>
                <!-- Third Row -->
                <div fxLayout="row" fxLayout.xs="column" class="mb-12 reservation-form-row">
                    <div fxLayout="column">
                        <!-- jour view xs  for less-->
                        <!-- jour  view xs for ex -->

                        <mat-form-field floatLabel="always" fxHide.gt-xs class="w-100-p lezem"
                            floatLabel="always" appearance="outline">
                            <mat-label>{{ 'reservationDialog.day' | transloco }}</mat-label>
                            <input autocomplete="off" matInput [matDatepicker]="startDatePicker" readonly
                                [placeholder]="'reservationDialog.start_date' | transloco" name="start" formControlName="debut"
                                (dateChange)="dateTimeChanged()" (click)="startDatePicker.open()" />
                            <mat-error>{{ 'reservationDialog.required_field' | transloco }}</mat-error>
                            <mat-datepicker-toggle matSuffix class="suffix" [for]="startDatePicker">
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field class="w-100-p lezem padd" fxHide.gt-xs floatLabel="always"
                            appearance="outline" >
                            <mat-label>{{ 'reservationDialog.start_time' | transloco }}</mat-label>
                            <div fxLayout="row" fxLayoutAlign="space-between center" >
                                <input class="mw" floatLabel="always" autocomplete="off" readonly matInput required
                                    [placeholder]="'reservationDialog.time' | transloco" formControlName="tempsDebut" [ngxMatTimepicker]="picker"
                                    [format]="24" />
                                <div>
                                    <ngx-mat-timepicker (timeSet)="dateTimeChanged()" [minutesGap]="15" #picker>
                                    </ngx-mat-timepicker>
                                    <ngx-mat-timepicker-toggle [for]="picker">
                                    </ngx-mat-timepicker-toggle>
                                </div>
                            </div>
                        </mat-form-field>
                    </div>


                    <!-- ?DATE  -->

                    <div class="w-100-p reservation-form-row" fxLayout="row">
                        <div class="div-large w-100-p field-stack" fxLayout="column" fxLayoutAlign="start start"
                            fxHide.xs>
                            <label class="input-label obligatoire">{{ 'reservationDialog.day' | transloco }}</label>
                            <mat-form-field floatLabel="always" class="w-100-p padd" floatLabel="always"
                                appearance="outline">
                                <input autocomplete="off" matInput [matDatepicker]="starDatePicker" readonly
                                    [placeholder]="'reservationDialog.start_date' | transloco" name="start" formControlName="debut"
                                    (dateChange)="dateTimeChanged()" (click)="starDatePicker.open()" />
                                <mat-error>{{ 'reservationDialog.required_field' | transloco }}</mat-error>
                                <mat-datepicker-toggle class="suffix" matSuffix [for]="starDatePicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #starDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>



                        <div class="div-large w-100-p field-stack" fxLayout="column" fxLayoutAlign="start start"
                            fxHide.xs>
                            <label class="input-label obligatoire">{{ 'reservationDialog.start_time' | transloco }}</label>
                            <mat-form-field class="w-100-p padd" floatLabel="always" appearance="outline">
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <input class="mw" floatLabel="always" autocomplete="off" readonly matInput
                                        [placeholder]="'reservationDialog.time' | transloco" formControlName="tempsDebut" (change)="dateTimeChanged()"
                                        (dateChange)="dateTimeChanged()" [ngxMatTimepicker]="picker2" [format]="24" />
                                    <div class="timepicker-toggle-offset">
                                        <ngx-mat-timepicker (timeSet)="dateTimeChanged()" [minutesGap]="15" #picker2>
                                        </ngx-mat-timepicker>
                                        <ngx-mat-timepicker-toggle [for]="picker2">
                                        </ngx-mat-timepicker-toggle>
                                    </div>
                                </div>
                            </mat-form-field>
                        </div>


                    </div>
                </div>


            </form>
            <!-- Form Footer -->
            <div class="m-0 " fxLayout="row" fxLayoutAlign="end center">
                <button [disabled]="reservationForm.pristine|| reservationForm.invalid" mat-raised-button
                    class="save-button mat-accent" [attr.aria-label]="'reservationDialog.save' | transloco" (click)='updateTestReservation()'>
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <svg *ngIf="loading" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" style="
                                margin: auto;
                                background: rgba(0, 0, 0, 0);
                                display: block;
                            " width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="75" cy="50" fill="#68b3d8" r="4.81593">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s"
                                    repeatCount="indefinite" begin="-0.9166666666666666s"></animate>
                                <animate attributeName="fill" values="#68b3d8;#68b3d8;#039be5;#68b3d8;#68b3d8"
                                    repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s"
                                    begin="-0.9166666666666666s"></animate>
                            </circle>
                            <circle cx="71.65063509461098" cy="62.5" fill="#68b3d8" r="4.51741">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s"
                                    repeatCount="indefinite" begin="-0.8333333333333334s"></animate>
                                <animate attributeName="fill" values="#68b3d8;#68b3d8;#039be5;#68b3d8;#68b3d8"
                                    repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s"
                                    begin="-0.8333333333333334s"></animate>
                            </circle>
                            <circle cx="62.5" cy="71.65063509461096" fill="#68b3d8" r="3.85074">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s"
                                    repeatCount="indefinite" begin="-0.75s"></animate>
                                <animate attributeName="fill" values="#68b3d8;#68b3d8;#039be5;#68b3d8;#68b3d8"
                                    repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.75s"></animate>
                            </circle>
                            <circle cx="50" cy="75" fill="#68b3d8" r="3.18407">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s"
                                    repeatCount="indefinite" begin="-0.6666666666666666s"></animate>
                                <animate attributeName="fill" values="#68b3d8;#68b3d8;#039be5;#68b3d8;#68b3d8"
                                    repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s"
                                    begin="-0.6666666666666666s"></animate>
                            </circle>
                            <circle cx="37.50000000000001" cy="71.65063509461098" fill="#68b3d8" r="3">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s"
                                    repeatCount="indefinite" begin="-0.5833333333333334s"></animate>
                                <animate attributeName="fill" values="#68b3d8;#68b3d8;#039be5;#68b3d8;#68b3d8"
                                    repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s"
                                    begin="-0.5833333333333334s"></animate>
                            </circle>
                            <circle cx="28.34936490538903" cy="62.5" fill="#68b3d8" r="3">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s"
                                    repeatCount="indefinite" begin="-0.5s"></animate>
                                <animate attributeName="fill" values="#68b3d8;#68b3d8;#039be5;#68b3d8;#68b3d8"
                                    repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5s"></animate>
                            </circle>
                            <circle cx="25" cy="50" fill="#68b3d8" r="3">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s"
                                    repeatCount="indefinite" begin="-0.4166666666666667s"></animate>
                                <animate attributeName="fill" values="#68b3d8;#68b3d8;#039be5;#68b3d8;#68b3d8"
                                    repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s"
                                    begin="-0.4166666666666667s"></animate>
                            </circle>
                            <circle cx="28.34936490538903" cy="37.50000000000001" fill="#68b3d8" r="3">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s"
                                    repeatCount="indefinite" begin="-0.3333333333333333s"></animate>
                                <animate attributeName="fill" values="#68b3d8;#68b3d8;#039be5;#68b3d8;#68b3d8"
                                    repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s"
                                    begin="-0.3333333333333333s"></animate>
                            </circle>
                            <circle cx="37.499999999999986" cy="28.349364905389038" fill="#68b3d8" r="3">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s"
                                    repeatCount="indefinite" begin="-0.25s"></animate>
                                <animate attributeName="fill" values="#68b3d8;#68b3d8;#039be5;#68b3d8;#68b3d8"
                                    repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.25s"></animate>
                            </circle>
                            <circle cx="49.99999999999999" cy="25" fill="#68b3d8" r="3">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s"
                                    repeatCount="indefinite" begin="-0.16666666666666666s"></animate>
                                <animate attributeName="fill" values="#68b3d8;#68b3d8;#039be5;#68b3d8;#68b3d8"
                                    repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s"
                                    begin="-0.16666666666666666s"></animate>
                            </circle>
                            <circle cx="62.5" cy="28.349364905389034" fill="#68b3d8" r="3.48259">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s"
                                    repeatCount="indefinite" begin="-0.08333333333333333s"></animate>
                                <animate attributeName="fill" values="#68b3d8;#68b3d8;#039be5;#68b3d8;#68b3d8"
                                    repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s"
                                    begin="-0.08333333333333333s"></animate>
                            </circle>
                            <circle cx="71.65063509461096" cy="37.499999999999986" fill="#68b3d8" r="4.14926">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s"
                                    repeatCount="indefinite" begin="0s"></animate>
                                <animate attributeName="fill" values="#68b3d8;#68b3d8;#039be5;#68b3d8;#68b3d8"
                                    repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="0s"></animate>
                            </circle>
                        </svg>
                        <span fxFlex>{{ 'reservationDialog.save' | transloco }}</span>
                    </div>
                </button>
            </div>
